import { Component, Directive, ElementRef, OnInit, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder } from '@angular/forms';


@Component({
  selector: 'app-schools-modal',
  templateUrl: './schools-modal.component.html',
  styleUrls: ['./schools-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SchoolsModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SchoolsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editData: any,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder
  ) {
  }

  ngOnInit(): void {

  }
}
